import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
    state: () => ({
        toasts: [],
        nextId: 1,
    }),
    actions: {
        addToast(toastData) {
            const id = this.nextId++;
            this.toasts.push({ id, ...toastData });
        },
        removeToast(id) {
            this.toasts = this.toasts.filter((toast) => toast.id !== id);
        },
    },
});
